import { useState } from 'react';

function useErrorManager() {
  const [errors, setErrors] = useState({});

  // Set an error for a specific operation
  const setError = (key, message) => {
    setErrors(prevErrors => ({
      ...prevErrors,
      [key]: message
    }));
  };

  // Clear error for a specific operation
  const clearError = (key) => {
    setErrors(prevErrors => ({
      ...prevErrors,
      [key]: null
    }));
  };

  // Get error by key
  const getError = (key) => errors[key];

  // Clear all errors
  const clearAllErrors = () => setErrors({});

  return {
    errors,
    setError,
    clearError,
    getError,
    clearAllErrors
  };
}

export default useErrorManager;
